const announcements2022Array = [
    {
        link: "https://iittp.ac.in/recruitment",
        title: "Advertisement for Non-Teaching Staff Positions (Regular) - Selected Results of Technical Officer - Systems (CC)",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/recruitment",
        title: "Advertisement for the Post of Registrar",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Short Listed candidates - Assistant Manger HoME - Jan 2023.pdf",
        title: "Shortlisted Candidates - Assistant Manager (HoME) (Outsourcing Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Shortlisted candidates - purchase - Jan 2023.pdf",
        title: "Shortlisted Candidates - Senior Project Executive - Purchase (CSRC)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/JE_Accounts_IITTPRECT-OS09_Results - Jan 2023.pdf",
        title: "Selected Candidates list - Finance & Accounts (Outsourcing Positions)",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/recruitment",
        title: "Advertisement for the position of Assistant Professor Grade-I in the various departments of the Institute",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTP RECT-OS1122_CC-Results.pdf",
        title: "Selected Candidates List - Computer Centre (Outsourcing Technical Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Physics Lab Asst_Shortlisted - Dec 22.pdf",
        title: "Shortlisted Candidates - Physics Lab Assistant (Outsourcing Position)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt IITTCSRC222315-SRF.pdf",
        title: "Notification for the post of Senior research fellow (SRF)- Last date extended upto 10th January 2023.",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTP RECT-OS11_Project Junior Executive & JE_Acct_Shortlisted - Jan 23.pdf",
        title: "Shortlisted Candidates - Finance & Accounts (Outsourcing Position)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/recruitment/faculty/Cancellation of SRD 01 of 2021.pdf",
        title: "Advertisement No. IITT/SRD/FAC - RMT -01/2021 is cancelled due to administrative reasons -  Cancellation Order",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/CC_IITTP RECT-OS1122_Shortlisted - Dec 22.pdf",
        title: "Shortlisted Candidates - Computer Centre (Outsourcing Technical Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/recruitment/2022/Corrigendum_IITTStaff RMT012022.pdf",
        title: "Corrigendum to the Advertisement No. IITT/Staff RMT/01/2022 dated 07.10.2022",
        modal: false,
    },
    {
        link: "#fa_12",
        title: "Notification for the Outsourcing Positions (Finance & Accounts)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt IITTCSRC22-2314_Updated.pdf",
        title: "Notification for the post of Postdoctoral Fellow",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/msphd-admissions/",
        title: "MS/Ph.D Admission January 2023 - Shortlised Candidates / Syllabus / Interview Schedule",
        modal: false,
    },
    {
        link: "#home_02",
        title: "Notification for Outsourcing Positions (HoME Office - Asst. Manager)",
        modal: true,
    },
    {
        link: "#csrc_28",
        title: "Notification for Outsourcing Positions (CSRC Office) - Last date extended upto 21st December 2022.",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/STFIITTPRECT-OS07-Results.pdf",
        title: "Results - Academics (Junior Executive)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advertisement for the post of project Officer_171224.pdf",
        title: "Advertisement for the position of Project Officer - CSRC (On Contract Basis)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advertisement for the post of project Associa_171131.pdf",
        title: "Advertisement for the position of Project Associate - CSRC (On Contract Basis)",
        modal: false,
    },
    {
        link: "#vri",
        title: "VRITIKA Research Internship: Techniques of Transition Metal-Catalyzed Organic Synthesis",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt IITTCSRC222312.pdf",
        title: "Advertisement for the post of Senior Software Developer and Software Developer on Contract Basis",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Academics Shortlisted_17-11-2022.pdf",
        title: "Shortlisted Candidates - Academics (Junior Executive)",
        modal: false,
    },
    {
        link: "#cc_14",
        title: "Notification for Outsourcing Technical Positions (Computer Center)",
        modal: true,
    },
    {
        link: "https://iittp.ac.in/information-for-b-tech-2022-batch",
        title: "Information for B.Tech 2022 Batch Students",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/academics/admissions",
        title: "M.S. (R) and Ph.D. Admissions - January 2023",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Results - General Admin-11-11-2022.pdf",
        title: "Results  - General Administration on Contract Basis",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Result of placement officer_11-11-2022.pdf",
        title: "Results  - Placement Officer on Contract Basis",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Result of counselling Psychologists.pdf",
        title: "Results  - Counselling Psychologist",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/shortlisted candidates for placement officer.pdf",
        title: "Shortlisted Candidates for Placement Officer",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt.IITTCCE2022-2312_New.pdf",
        title: "Advertisement for the post of Project Manager at CCE on Contract Basis",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/shortlisted candidates for counselling psychologist.pdf",
        title: "Shortlisted Candidates for Counselling Psychologist",
        modal: false,
    },
    {
        link: "#cp",
        title: "Advertisement for the Counselling Psychologist on Contract Basis",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt IITTCSRC222310.pdf",
        title: "Advertisement for the position of Junior Research Fellow (JRF) - CSRC",
        modal: false,
    },
    {
        link: "#lap",
        title: "Notification for the Laboratory Assistant (Physics) - Outsourced Positions",
        modal: true,
    },
    {
        link: "#po",
        title: "Notification for the Placement Officer - On Contract Basis",
        modal: true,
    },
    {
        link: "#openhouse",
        title: "Open House Interactive Session for Prospective Students",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt IITT CSRC222311(Date-Extended).pdf",
        title: "Advertisement for the position of Senior Project Fellow - CSRC (Last date extended up to 15th October, 2022)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/STFIITTPRECT-OS06-Gen_Adm Shortlisted-Oct 22.pdf",
        title: "Shortlisted Candidates - General Administration (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/M.Sc_2022_SPOT_Admission.pdf",
        title: "M.Sc 2022 Spot Admissions Advertisement",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Rsults_Health Centre-STFIITTPRECT-OS05.pdf",
        title: "Results - Health Center (Outsourced Positions)",
        modal: false,
    },
    {
        link: "#ws",
        title: "Notification for the Central Workshop - Outsourced Positions (Last date extended up to 25th Sep, 2022)",
        modal: true,
    },
    {
        link: "#po",
        title: "Notification for the Placement Officer - On Contract Basis",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Health Centre  Shortlisted-STFIITTPRECT-OS05.pdf",
        title: "Shortlisted Candidates - Health Center (Outsourced Positions)",
        modal: false,
    },
    {
        link: "#am",
        title: "Notification for the Assistant Manager, HoME Office - Outsourced Positions",
        modal: true,
    },
    {
        link: "#je",
        title: "Notification for the Junior Executive, Academics - Outsourced Positions",
        modal: true,
    },
    {
        link: "#gm",
        title: "Notification for the General Administration - Outsourced Positions",
        modal: true,
    },
    {
        link: "#tsi1",
        title: "VRITIKA Research Internship: Advanced Surface Alloy Coatings During Manufacturing for Water Industry Components",
        modal: true,
    },
    {
        link: "#tsi2",
        title: "VRITIKA Research Internship: Metal Matrix Nano Composites for Automotive Components",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/RESULTS - Sports Coaches_8-9-2022.pdf",
        title: "Results - Sports Coaches  (Outsourced Positions)",
        modal: false,
    },
    {
        link: "#hc",
        title: "Notification for the Nursing Practitioner (Health Centre) - Outsourced Positions",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/EU-RESULTS_STFIITTPRECT-OS03.pdf",
        title: "Results - Engineering Unit (Outsourcing Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/CC_Resultd-IITTPRECT-OS0322.pdf",
        title: "Results - Outsourcing Technical Positions (Computer Center)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Shortlisted Candidates - CC Aug 2022.pdf",
        title: "Shortlisted Candidates for Outsourcing Technical Positions (Computer Center)",
        modal: false,
    },
    {
        link: "#home_06",
        title: "Notification for the Post of Manager - Outsourcing Positions (Hostel and Mess Establishment (Home) Office)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/STFIITTPRECT-OS03_Aug2022.pdf",
        title: "Engineering Unit - Shortlisted Candidates for Outsourcing Positions",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/TIH - Chanakya Fellowship Selected Candidates.pdf",
        title: "TIH - Chanakya Fellowship  - Ph.D. - Selected Candidates list",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Sports_Coaches_Recruitment_Notification-STFM.pdf",
        title: "Notification for Engagement of Part-Time Coach",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advt IITTCSRC22-2309.pdf",
        title: "Advertisement for the position of Junior Research Fellow (JRF) - CSRC",
        modal: false,
    },
    {
        link: "#EU",
        title: "Notification for the Engineering Unit Outsourced Positions (Extend the last date up to 07 Aug, 2022)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/AdvtIITT222308.pdf",
        title: "Advertisement for the position of Research Scholar - CSRC",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/FINAL_SELECTION_HoME_MANAGER_July.pdf",
        title: "Results - Post of Manager - Outsourcing Positions (HoME)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/EU_RESULTS_JULY_2022.pdf",
        title: "Results - Outsourced Positions (Engineering Unit)",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/msphd-admissions/",
        title: "Results - M.S (Research) / Ph.D. - Selected Candidates List",
        modal: false,
    },
    {
        link: "#cc_06",
        title: "Notification for Outsourcing Technical Positions (Computer Center)",
        modal: true,
    },
    {
        link: "#home_06",
        title: "Notification for the Post of Manager - Outsourcing Positions (Hostel and Mess Establishment (Home) Office)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advertisement-Project Scientist I.pdf",
        title: "Advertisement for the position of Project Scientist I - CSRC",
        modal: false,
    },
    {
        link: "#special",
        title: "Special Call for Ph.D. Admissions at IIT Tirupati (Chanakya Fellowship)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/EU-Shortlisted candidates.pdf",
        title: "Shortlisted candidates - Engineering Unit (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/JE (Accounts)_FINAL SELECTION.pdf",
        title: "Final Result -  Junior Executive (Accounts)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Result-JE_ADM and Admin Assistant.pdf",
        title: "Results - Outsourced Positions",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/msphd-admissions/",
        title: "MS/Ph.D. Written Test / Interview Schedule",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/msphd-admissions/",
        title: "MS/Ph.D. Examination / Interview Syllabus",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/MPP Syllabus_06_05_2022.pdf",
        title: "Master of Public Policy Examination Syllabus",
        modal: false,
    },
    {
        link: "#Outsourcing",
        title: "Notification of walk-in interview for Audit Officer",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Inauguration for M. Sc. Physics program on Monday 31st August 2020_v7.pdf",
        title: "Inauguration of M.Sc Physics Program",
        modal: false,
    },
    {
        link: "#msc",
        title: "Launching Masters in Chemistry @ IIT Tirupati",
        modal: true,
    },
    {
        link: "#const",
        title: "Celebration of Constitution Day",
        modal: true,
    },
    {
        link: "https://iittp.ac.in/convocation2021",
        title: "Convocation 2021 - Live Streaming",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/IITT Convocation e-Invitation.pdf",
        title: "2nd & 3rd Convocation - 25th September 2021",
        modal: false,
    },
    {
        link: "/doc/Hindi Consultant Advertisement_12-11-2021.pdf",
        title: "Advertisement for Hindi Consultant-Last Date extended",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Advertisement for the position of JRF_10_5_2022.pdf",
        title: "Advertisement for the position of JRF",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/Winners_list Sciencehack_2022.pdf",
        title: "SCIENCE HACK 2.0 2022 WINNERS LIST",
        modal: false,
    },
    {
        link: "#instday",
        title: "7th Institute Day - April 6th 2022",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Cricket Coach Notification.pdf",
        title: "Advt. for Part Time Cricket Coach",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Publishing results .pdf",
        title: "JE (General) & MSW - Results",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisement for JE (Accounts)-262022.pdf",
        title: "Advertisement for Junior Executive (Accounts)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/HoME sports RESULTS.pdf",
        title: "Part time coaches/gym instructors - Results",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/academics/admissions",
        title: "M.Tech/MPP/M.S/Ph.D Admissions - August 2022",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advt. for Project Manager ( Admin.).pdf",
        title: "Advt. for Project Manager - CSRC",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/___ Advt. for Assitant Manager (Accounts).pdf",
        title: "Advt. for Assistant Manager - CSRC",
        modal: false,
    },
    {
        link: "#opos",
        title: "Advertisment for Outsourced Positions",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Shortlisted Candidate_MSW.pdf",
        title: "Shortlisted Candidates - Multi Skilled Worker",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Result - Pr Asst - CC Admin.pdf",
        title: "Project Assistant (Administration) - Results",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisement_JRF_ME_March2022.pdf",
        title: "Advt. for JRF - Dept. of ME",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/CC Results.pdf",
        title: "Results - Outsourced Positions",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisement for JRF-CEE.pdf",
        title: "Advt. for JRF - Dept. of CEE",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Shortlisted Candidates HoME.pdf",
        title: "Shortlisted Candidates - Junior Executive (Accounts & General)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Shortlisted Candidates Proj Assistant - CC.pdf",
        title: "Shortlisted Candidates - Project Assistant (Administration)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/EOI - School.pdf",
        title: "EOI for Campus Pre-School",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisment for SRF - Dr Ajay Kumar.pdf",
        title: "Advt. for SRF - Dept. of Mechanical Engg.",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Extesnsion of last date - Coaches recruitment.pdf",
        title: "Extended Last Date for the Notification for Part Time Coaches/GYM Instructor",
        modal: false,
    },
    {
        link: "#hack",
        title: "Science Hack - 2.0",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Shortlisted Candidates - HoME.pdf",
        title: "HoME Staff - Shortlisted Candidates",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisement for JRF-Dr Nabil M.pdf",
        title: "Advertisment for JRF - Dept. of Chemical Engg.",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/JRF-Jan132022.pdf",
        title: "Advertisment for JRF - Dept. of ME",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/JT & ST.pdf",
        title: "Advt. for JT & ST - Depts. of CEE and ME",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Research Scholar-Civil Engineering.pdf",
        title: "Advt. for Research Scholar - Dept. of CEE",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Research Scholar-Mechanical Engineering.pdf",
        title: "Advertisment for Research Scholar - Dept. of ME",
        modal: false,
    },
    {
        link: "#chanakya",
        title: "Call for Proposals - CHANAKYA Fellowships - Last date extended till 25th Jan 2022",
        modal: true,
    },
];

export default announcements2022Array;
